var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "tls-popup--body-slot" }, [
      _c("div", {
        directives: [
          {
            name: "dompurify-html",
            rawName: "v-dompurify-html",
            value: _vm.simpleText,
            expression: "simpleText"
          }
        ]
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "tls-popup--body-slot" }, [
      _vm.videoLink
        ? _c("iframe", {
            attrs: {
              src: _vm.videoLink,
              title: "video",
              frameborder: "0",
              allowfullscreen: ""
            }
          })
        : _vm._e()
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }